import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../shared/utility';
import * as actions from '../../store/actions/index';
import Messages from '../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../shared/Config';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { Fieldset } from 'primereact/fieldset';
const Inputs = ({ field, metaData, onInputChange, ...props }) => {

    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={metaData}
    /> || null;

}

const BREAK_PERMISSION_ID = '49c4ee4c-fb3e-43f3-bcf4-6dac36a9549b';


class BreakPermissionRequest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            stageSequence: 0,
            requestDate: moment(),
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit'
        }
        this.initialize = this.initialize.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
    }


    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        this.setState({
            process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue: field.fieldName === name && (field.fieldDescription === 'From Time' || field.fieldDescription === 'To Time') ? moment(value).format('HH:mm') : field.fieldName === name ? value : field.fieldValue })) }))
        });


    }

    initialize = (process, type) => {
        this.setState({ loading: true });
        const { tableLists, location = {} } = this.props;
        const { state = {} } = location;
        const { stageSequence, requestDate } = this.state;
        const status = state.editStatus || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith
        const requestFrom = location && location.state && location.state.requestFrom;
        let count = 1;
        let sequence = 1;
        const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
            const stageField = arraySort(stage.stage_Field, 'fieldSequence');
            return Object.assign({}, { ...stage }, {
                stage_Field: stageField.reduce((a, el) => {
                    const startIndex = el.fieldName.substring(0, 10);
                    if (type === 'add') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === 'Request Date' && requestDate) || (el.fieldDescription === 'Attendance Date' && state.attendanceDate) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                    } else if (type === 'edit') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') ||  (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                            el.stage_FieldsList.map((subField, subIndex) => {
                                if (subIndex != 0) {
                                    subField.stage_FieldsListc2.map(c2 => {
                                        a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                    })
                                }
                            })
                        }
                    }
                    return a;
                }, [])
            })
        });

        if (InitialValues && InitialValues.length > 0)
            this.setState({ loading: false, process: InitialValues });

    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process,requestId } = this.state;
        const type = this.props.match.params.type;
        const {  location = {} } = this.props;
        let RequestedFor = '';
        let FromDate = '';
        let ToDate = '';
        let RequestDate = new Date();
        let Comment = false;
        let RequestAttributes = [];
        var time1 = '';
        var time2 = '';
        var reasoncode =''
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'Requested For') {
                    RequestedFor = el.fieldValue;
                } else if (el.fieldDescription === 'Attendance Date') {
                    FromDate = moment(el.fieldValue).format('MM/DD/YYYY');
                    ToDate = moment(el.fieldValue).format('MM/DD/YYYY');
                } else if (el.fieldDescription === 'Request Date') {
                    RequestDate = el.fieldValue;
                } else if(el.fieldDescription === 'Comment' && stageIndex === 0){
                    Comment = el.fieldValue;
                } else if(el.fieldDescription === 'From Time' && stageIndex === 0){
                    time1 = el.fieldValue;
                } else if(el.fieldDescription === 'Reason Code' && stageIndex === 0){
                    reasoncode = el.fieldValue;
                }                   
                else if(el.fieldDescription === 'To Time' && stageIndex === 0){
                    time2 = el.fieldValue;
                }
                

                RequestAttributes.push(Object.assign({}, {...el}, {fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue}));
            })
        });
        


        if(!Comment){
            this.growl.show({severity: 'error', summary: null, detail: 'Comment is Mandatory'});
            return;
        }

        function solve(arr){

            let msChecker = 10000000000000000;
            for ( let i = 0; i < arr.length; i++) {   
              if (i % 2 === 0) { 
                console.log(arr[i])
            let start = new Date("August 21, 2019 " + arr[i]);
            let end = new Date("August 21, 2019 " + arr[i+1]);
            let ms = Math.floor(end - start);
            console.log(ms)
            if ( ms < msChecker) { 
              msChecker = ms
            }
              }
            }
             let minutes = Math.floor(msChecker/1000/60)
            let hours =  Math.floor(msChecker/1000/60/60)
            console.log(hours)
            console.log(minutes)
            //minutes = minutes - (hours*60)
            console.log(minutes)
           // minutes-=1;
            //return hours.toString().concat(":",minutes.toString())
            return minutes.toString()
            }
            
        var diff = solve([time1, time2]);
        var diffint = parseInt(diff);
        if ( diffint > 180 && location.pendingWith==null && reasoncode !== "6")
        {
            this.growl.show({severity: 'error', summary: null, detail: 'Break Permission for Personal Reason is not allowed for more than three hrs'});
            return;   
        }



        let data = {
            FromDate: FromDate,
            ToDate: ToDate,
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Break Permission Request',
            IsActive: true,
            RequestDate: RequestDate,
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: RequestedFor,
            ProcessID: BREAK_PERMISSION_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: [],
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'BreakPermission';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'BreakPermission';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'BreakPermission';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'BreakPermission';
            }

            if (submitType === 'cancel') {
                model = 'BreakPermission';
            }




            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }


            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };
            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To" , popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Break Permission request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Break Permission request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    componentDidMount() {
        const { getContainerData, getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, location = {} } = this.props;
        const type = this.props.match.params.type;
        getContainerData(BREAK_PERMISSION_ID);//Get Container Data
        getMasterKeywordList('Shift');// Get Shift Dropdown list
        getMasterKeywordList('REASON_CODE');// Get reason code dropdown list
        getKeywordValues('Employee');//Get Employee Dropdown list

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);
        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || [];
            }

            if (process && process.length > 0 && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000)
                clearTimer();
            }
        }, 300);

    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList:[], subordinatesListData:[] })
    }
    
    render() {
        const { tableLists, location = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence } = this.state;

        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith
        const requestFrom = location && location.state && location.state.requestFrom;

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );
       let quotaDetails=[];
        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                       <Link to={'/break-permission-process'} style={{  color: 'blue', cursor: 'pointer' }}>
      Break Permission
    </Link>
                            <Link to={'/break-permission-process'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    return <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {(field.fieldDescription === 'From Time' || field.fieldDescription === 'To Time') ?
                                            <div className="p-col-12">
                                                <label className="label">
                                                    {field.fieldDescription}
                                                    <span className="requiredColor">*</span>
                                                </label>
                                                <div className="mt1">
                                                    <Calendar 
                                                        name={field.fieldName} 
                                                        readOnlyInput={true}
                                                        timeOnly={true} 
                                                        showTime={true} 
                                                        hourFormat="12" 
                                                        style={{width: '100%'}}
                                                        value={field.fieldValue && moment(field.fieldValue, 'HH:mm').toDate() || false} 
                                                        disabled={field.disabled}
                                                        onChange={(e) => this.handleChange(e, field)} />
                                                </div>
                                            </div> :
                                            
                                            <Inputs
                                                field={field}
                                                value={field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                enablePastDate={true}
                                                {...this.props}
                                                {...this.state} />}

                                    </div>


                                })}


                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/break-permission-process'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith !== null ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/break-permission-process'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                                    { 
// (stageFields[keys[0]].FieldValue !== null && this.props.quotaDetails && this.props.quotaDetails.length > 0) &&
                                                <div className="p-col-12" style={{marginTop:'2em',marginBottom:'2em'}}>
                                                    <Fieldset legend="Leave Quota" toggleable={true}>
                                                        <table className="tableBorder">
                                                        <thead>
                                                            <tr style={{background:'#f4f4f4'}}><th scope="col">Leave Type</th><th scope="col">Allocated Days </th><th scope="col">Used Leave</th><th scope="col">Balance days</th></tr>
                                                        </thead>
                                                        <tbody>
                                                            {quotaDetails}
                                                        </tbody>
                                                    </table>
                                                    </Fieldset>
                                                </div>
                                                }
                                                { 
// (stageFields[keys[0]].FieldValue !== null && this.props.quotaDetails && this.props.quotaDetails.length > 0) &&
                                                <div className="p-col-12" style={{marginTop:'2em',marginBottom:'2em'}}>
                                                    <Fieldset legend="Leave Quota" toggleable={true}>
                                                        <table className="tableBorder">
                                                        <thead>
                                                            <tr style={{background:'#f4f4f4'}}><th scope="col">Leave Type</th><th scope="col">Allocated Days </th><th scope="col">Used Leave</th><th scope="col">Balance days</th></tr>
                                                        </thead>
                                                        <tbody>
                                                            {quotaDetails}
                                                        </tbody>
                                                    </table>
                                                    </Fieldset>
                                                </div>
                                                }
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = state => {
    const subordinatesList = ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, {...el}, {value: el.uniqueId}));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), {label: `${state.auth.userObject.userName} (Self)`, value:state.auth.userObject.empID , id: parseInt(state.auth.userObject.userID)})]);

    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        keywordValuesList,
        metaData: Object.assign({}, {
            Shift: state.keyword.Shift,
            'Requested For': subordinatesList,
            'Reason Code': state.keyword.REASON_CODE
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(BreakPermissionRequest);